<template>
  <el-table-column
    prop="status"
    label="Státusz"
    show-overflow-tooltip
    width="150px"
  >
    <template slot-scope="scope">
      <status-cell :todo="scope.row" :type="type" />
    </template>
  </el-table-column>
</template>

<script>
import StatusCell from './StatusCell';

export default {
  propName: 'status',
  components: { StatusCell },
  props: ['type'],
  data() {
    return {
      isOpen: false,
      todo_LOADER: false,
      ['in-progress_LOADER']: false,
      done_LOADER: false,
      TODO_STATUS: {
        todo: {
          type: 'danger',
          title: 'Elintézendő',
        },
        ['in-progress']: {
          type: 'warning',
          title: 'Folyamatban',
        },
        done: {
          type: 'success',
          title: 'Kész',
        }
      }
    };
  },
  methods: {
    getStatus(todo) {
      if (todo.status) {
        return this.TODO_STATUS[todo.status];
      }
    },
    async setStatus(status) {
      this[`${status}_LOADER`] = true;
      await this.$store.dispatch('todos/updateStatus', {
        repairId: this.repair.id,
        status
      });
      this.isOpen = false;
      this[`${status}_LOADER`] = false;
    }
  }
};
</script>

<style>
  .todo-status-setter p:last-child {
    margin-bottom: 0;
  }
</style>
